import { useQuery } from "@tanstack/react-query";
import { fetchContacts } from "@a/contacts";

export function useContactsQuery(ownerId: string) {
  return useQuery({
    queryKey: ["contacts", ownerId],
    queryFn: () => fetchContacts(ownerId),
    enabled: !!ownerId,
  });
}
